import { Block } from "@convertkit/slate"

export default ({ blocks }, editor) => {
  const { document, startBlock } = editor.value

  const listItem = document.getParent(startBlock.key)
  if (listItem.type != blocks.list_item) return
  const list = document.getParent(listItem.key)
  const parentListItem = document.getParent(list.key)
  if (parentListItem.type != blocks.list_item) return
  const parentList = document.getParent(parentListItem.key)

  const index = parentList.nodes.indexOf(parentListItem)

  const otherItems = list.nodes.skipUntil(item => item === listItem).rest()

  if (!otherItems.isEmpty()) {
    // The item we are decreasing the depth for is part of a list that
    // contains items after itself. Example:
    // • Item 1
    //   • Item 2
    //   • Item 3 (current item)
    //   • Item 4 ┓
    //   • Item 5 ┣━ These are `otherItems`
    //   • Item 6 ┛
    // When we decrease the list depth of Item 3, we move Item 3 to the
    // parent list, and create a new list to contain `otherItems`
    const newList = Block.create({
      object: "block",
      type: list.type
    })

    editor.withoutNormalizing(() => {
      editor.insertNodeByKey(listItem.key, listItem.nodes.size, newList)

      editor.moveNodeByKey(listItem.key, parentList.key, index + 1)

      otherItems.forEach((item, index) =>
        editor.moveNodeByKey(item.key, newList.key, newList.nodes.size + index)
      )
    })
  } else {
    editor.withoutNormalizing(() => {
      editor.moveNodeByKey(listItem.key, parentList.key, index + 1)
      // If the item we are decreasing the depth for is the only item
      //  in its list, then remove that list.
      if (list.nodes.size === 1) editor.removeNodeByKey(list.key)
    })
  }
}
